import gql from 'graphql-tag'

export const GET_ARRIVAL_VIEW_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
		$query: String
		$branchId: Int
  ) {
    getArrivalViewPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
				query: $query
				branchId: $branchId
      }
    ) {
      hasMore
      total
      items {
				id
        product {
					id
					productInfo {
						titleRu
						titleKg
						titleEn
					}
					coverImage
				}
				branch {
					id
					titleEn
					titleRu
					titleKg
				}
				quantity
      }
    }
  }
`;

export const GET_ARRIVAL_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
		$query: String
		$branchId: Int
		$productId: Int
		$activeStatus: Boolean! = true
		$status: ArrivalStatus
  ) {
    getArrivalPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
				query: $query
				branchId: $branchId
				productId: $productId
				activeStatus: $activeStatus
				status: $status
      }
    ) {
      hasMore
      total
      items {
				id
        product {
					id
					productInfo {
						titleRu
						titleKg
						titleEn
					}
					coverImage
				}
				branch {
					id
					titleEn
					titleRu
					titleKg
				}
				quantity
				status
				note
      }
    }
  }
`;

export const GET_ARRIVAL_LIGHT_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
		$branchId: Int
		$productId: Int
  ) {
    getArrivalLightPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
				branchId: $branchId
				productId: $productId
      }
    ) {
      hasMore
      total
      items {
				id
				buyPrice
				currencyObj {
					symbol
				}
				arrivedAt
				quantity
				note
      }
    }
  }
`;

export const GET_ARRIVAL_WITH_EXTRA_DATA_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getArrival (
      data: {
        id: $id
      }
    ) {
      id
			branch {
				id
				titleEn
				titleRu
				titleKg
			}
			branchId
			productId
			product {
				id
				prices {
					currency
					price
					overprice
					wholesalePrice
				}
				discount
				quantity
				status
				tag
			}
			quantity
			buyPrice
			currency
			currencyObj {
				symbol
			}
			note
			arrivedAt
			status
    }
		getAllBranches {
			id
			titleEn
			titleRu
			titleKg
		}
		getAllCurrencies {
			title
			symbol
			left
		}
		getCurrentExchangeRateGroup {
			id
			defaultCurrency {
				title
				symbol
				main
			}
			rates {
				id
				currency {
					title
					symbol
					main
				}
				value
			}
		}
		getCurrentArrivalProductMarkup(productId: $id, isArrival: true) {
			id
			fromPrice
			toPrice
			productId
			price
			overprice
			wholesalePrice
		}
		getLastArrival (
			productId: $id
			isArrival: true
		) {
			last {
				id
				quantity
				buyPrice
				currency
				currencyObj {
					symbol
				}
				arrivedAt
			}
			lastBranchArrival {
				id
				quantity
				buyPrice
				currency
				currencyObj {
					symbol
				}
				arrivedAt
			}
			allQuantities
			branchQuantities
		}
  }
`;

export const GET_ARRIVAL_EXTRA_DATA_QUERY = gql`
  query {
    getAllBranches {
      id
      titleEn
      titleRu
      titleKg
    }
		getAllCurrencies {
			title
			symbol
			left
		}
		getCurrentExchangeRateGroup {
			id
			defaultCurrency {
				title
				symbol
				main
			}
			rates {
				id
				currency {
					title
					symbol
					main
				}
				value
			}
		}
  }
`;

export const GET_ARRIVAL_FROM_PRODUCT_QUERY = gql`
  query {
		getAllBranches {
			id
			titleEn
			titleRu
			titleKg
		}
		getAllCurrencies {
			title
			symbol
			left
		}
		getCurrentExchangeRateGroup {
			id
			defaultCurrency {
				title
				symbol
				main
			}
			rates {
				id
				currency {
					title
					symbol
					main
				}
				value
			}
		}
		getCurrentArrivalProductMarkup {
			id
			fromPrice
			toPrice
			productId
			price
			overprice
			wholesalePrice
		}
  }
`;

export const GET_LAST_ARRIVAL_WITH_EXTRA_DATA_QUERY = gql`
  query (
		$productId: Int!,
		$branchId: Int
  ) {
    getLastArrival (
      productId: $productId
			branchId: $branchId
    ) {
      last {
				id
				quantity
				buyPrice
				currency
				currencyObj {
					symbol
				}
				arrivedAt
			}
			lastBranchArrival {
				id
				quantity
				buyPrice
				currency
				currencyObj {
					symbol
				}
				arrivedAt
			}
			allQuantities
			branchQuantities
    }
		getProduct (
			data: {
				id: $productId
			}
		) {
			id
			prices {
				currency
				price
				overprice
				wholesalePrice
			}
			discount
			quantity
			status
			tag
		}
		getCurrentArrivalProductMarkup(productId: $productId) {
			id
			fromPrice
			toPrice
			productId
			price
			overprice
			wholesalePrice
		}
  }
`;

export const GET_LAST_ARRIVAL_QUERY = gql`
  query (
		$productId: Int!,
		$branchId: Int
  ) {
    getLastArrival (
      productId: $productId
			branchId: $branchId
    ) {
      last {
				id
				quantity
				buyPrice
				currency
				currencyObj {
					symbol
				}
				arrivedAt
			}
			lastBranchArrival {
				id
				quantity
				buyPrice
				currency
				currencyObj {
					symbol
				}
				arrivedAt
			}
			allQuantities
			branchQuantities
    }
  }
`;

export const GET_ARRIVAL_HISTORY_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
		$query: String
		$fromDate: DateString
		$toDate: DateString
		$action: ArrivalHistoryAction
  ) {
    getArrivalHistoryPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
				query: $query
				fromDate: $fromDate
				toDate: $toDate
				action: $action
      }
    ) {
      hasMore
      total
      items {
				id
        arrivalIds
        action
        createdAt
        user {
					shortFullName
        }
        data
      }
    }
  }
`;
